import { render, staticRenderFns } from "./ManifestKlaimCCPp.vue?vue&type=template&id=1e48f979&scoped=true&"
import script from "./ManifestKlaimCCPp.vue?vue&type=script&lang=js&"
export * from "./ManifestKlaimCCPp.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKlaimCCPp.vue?vue&type=style&index=0&id=1e48f979&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48f979",
  null
  
)

export default component.exports